import type { FC, ReactNode } from "react";

import {
  Button,
  type ButtonProps,
  classes,
  Link,
  Text,
} from "@alpacahq/ui/old";

export type PlanBoxProps = {
  tagline: ReactNode;
  title: ReactNode;
  subTitle?: ReactNode;
  list: ReactNode[];
  button: {
    variant: ButtonProps["variant"];
    text: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
  };
  learnMore?: string;
  className?: string;
};

export const PlanBox: FC<PlanBoxProps> = ({
  tagline,
  title,
  subTitle,
  list,
  button,
  learnMore,
  className,
}) => (
  <div
    className={classes(
      "flex w-full max-w-72 flex-col justify-between justify-self-center rounded-lg px-4 pt-4",
      className,
    )}
  >
    <Text>
      <span className="block pb-1">{tagline}</span>
      <span className="block font-bold text-2xl">{title}</span>
      <span className="block min-h-4 font-semibold text-sm">{subTitle}</span>
    </Text>
    <div className="flex h-full flex-col justify-between">
      <ul className="py-4">
        {list.map((item) => (
          <li key={String(item)} className="ml-4 list-disc py-1">
            {item}
          </li>
        ))}
      </ul>
      <div>
        <Button
          onClick={button.onClick}
          disabled={button.disabled}
          variant={button.variant}
          className="w-full"
        >
          {button.text}
        </Button>
        <div className="flex h-8 w-full items-center justify-center text-sm">
          {learnMore && <Link href={learnMore}>Learn More</Link>}
        </div>
      </div>
    </div>
  </div>
);
